<template>
    <div class="field" style="padding-right: 5px;">
        <a class="button is-theme-primary is-small"
           v-bind:class="{ 'is-loading': isLoading }"
           @click.prevent="addToFavorites()">
            <span class="icon is-small">
                <i class="fas fa-plus"></i>
            </span>
            Favorite
        </a>
    </div>
</template>

<script>
    import apiFavorites from '../../../../api/apiFavorites'
    export default {
        props: ['bid'],
        data() {
            return {
                isLoading: false,
                newFavorite: {
                    lot_id: this.bid.lot_id
                }
            }
        },
        methods: {
            addToFavorites() {
                this.isLoading = true
                apiFavorites
                    .createFavoritesRequest({lot_id: this.bid.lot_id})
                    .then((response) => {
                        this.isLoading = false
                        this.bid.favorite = [
                            {
                                lot_id: this.bid.lot_id
                            }
                        ]

                    })
                    .catch((err) => {
                        console.log(err)
                        this.isLoading = false
                    })
            }
        }
    }

</script>

<style scoped>
    .button {
        font-weight: 700;
    }
    .button .icon:first-child:last-child {
        margin-right: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/Card/Buttons/Lots/FavoriteCreate.vue